<template>
  <div class="store-health-check">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card class="mt-2">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('store.status') }}</strong>
            </div>
            <b-row>
              <b-col cols="12">
                <div class="pull-right">
                  <b-input-group v-bind:prepend="$t('store.status')">
                    <b-dropdown variant="default">
                      <template v-slot:button-content>
                        <img :src="selectedStatus.img" width="15" v-if="selectedStatus.img != null"> <span>{{$t(selectedStatus.title)}}</span>
                      </template>
                      <b-dropdown-item :key="option.title" v-for="option in statusOptions" @click="setStatus(option)">
                        <img :src="option.img" width="15"> <span>{{$t(option.title)}}</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-input-group>
                </div>
              </b-col>
              <b-col cols="12">
                <div id="myMap"></div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col cols="12">
          <b-card class="mt-2">
            <div slot="header">
              <i className="fa fa-align-justify"></i><strong class="text-uppercase">{{ $t('store.details') }}</strong>
            </div>
            <b-row>
              <b-col cols="6">
                <div class="pull-right">
                  <b-input-group v-bind:prepend="$t('store.status')">
                    <b-dropdown variant="default">
                      <template v-slot:button-content>
                        <img :src="filter.status.img" width="15" v-if="filter.status.img != null"> <span>{{$t(filter.status.title)}}</span>
                      </template>
                      <b-dropdown-item :key="option.title" v-for="option in statusOptions" @click="setStatusDatatable(option)">
                        <img :src="option.img" width="15"> <span>{{$t(option.title)}}</span>
                      </b-dropdown-item>
                    </b-dropdown>
                  </b-input-group>
                </div>
              </b-col>
              <b-col xl="6">
                <b-input-group>
                  <select-dropdown v-bind:options="filter.options" v-bind:selected="filter.selected" position="prepend" v-bind:all="false" v-model="filter.field" prefix="menu">
                  </select-dropdown>
                  <input type="text" class="form-control" v-model="filter.key" v-on:keydown.enter="getLatestStoreStatusDatatable"/>
                  <div class="input-group-append">
                    <b-input-group-append>
                      <b-btn @click="getLatestStoreStatusDatatable()"><i class="fa fa-search" ></i> {{$t('common.search')}}</b-btn>
                    </b-input-group-append>
                  </div>
                </b-input-group>
              </b-col>
              <b-col cols="12">
                <!-- Start of Data table session -->
                <div class="table-responsive single-data">
                  <table class="table table-striped table-hover table-sm table-bordered">
                    <thead>
                    <tr>
                      <th scope="col" v-for="item in dataTable.fields" :key="item.id">
                        <span v-if="item.label != null">{{$t('store.'+item.label)}}</span>
                        <span v-if="item.label == null">{{$t('store.'+item.name)}}</span>
                      </th>
                      <th scope="col">{{$t('common.action')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-if="dataTable.items.length == 0">
                      <td class="text-center" :colspan="dataTable.fields.length + 1">
                        {{$t('message.no_data')}}
                      </td>
                    </tr>
                    <tr v-for="item in dataTable.items" :key="item.id">
                      <td scope="row" class="text-left" v-for="field in dataTable.fields" :key="field.id">
                        <span v-if="field.render != null" v-html="field.render(item[field.name], item)"></span>
                        <span v-if="field.render == null">
                        {{item[field.name]}}
                      </span>
                      </td>
                      <td scope="row" width="100">
                        <b-button size="sm" variant="primary" class="btn-margin" v-on:click="getDetails(item.store_code)">
                          <i class="fa fa-eye"></i> {{$t('common.details')}}
                        </b-button>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
                <!-- End of Data table session -->

                <!-- Start of paginate session -->
                <b-row>
                  <b-col>
                    <b-pagination :total-rows="dataTable.total" :per-page="dataTable.perPage"
                                  v-model="dataTable.currentPage"/>
                  </b-col>
                  <b-col class="text-left">
                    {{$t('message.datatable_total', {number: dataTable.items.length, total: dataTable.total})}}
                  </b-col>
                  <b-col col lg="1">
                    <b-form-select v-model="dataTable.perPage" :options="[10, 20, 50, 100, 200, 500]" class="mb-3"/>
                  </b-col>
                </b-row>
                <!-- Start of paginate session -->
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <!-- Copy -->
    <b-modal class="modal-store-detail" ref="storeDetailModal" v-bind:title="$t('store.details')" size="xl" body-class="padding-none" ok-variant="bg-main border-radius-4px pl-3 pr-3">
      <b-row>
        <b-col md="3" sm="6">
          <div class="social-box">
            <i class="fa bg-dark color-white" v-if="outletsData[selectedStoreCode] != null">
              <span>{{outletsData[selectedStoreCode].name[$session.get('lang')]}}</span>
              <h5>{{outletsData[selectedStoreCode].code}}</h5>
              <h5>{{outletsData[selectedStoreCode].ip}}</h5>
              <h5>{{outletsData[selectedStoreCode].address[$session.get('lang')]}}</h5>
            </i>
            <ul>
              <li>
                <strong>{{dataTableDetail.total}}</strong>
                <span>{{$t('common.total')}}</span>
              </li>
              <li>
                <strong>{{dataTableDetail.false}}</strong>
                <span>{{$t('common.disconnected')}}</span>
              </li>
            </ul>
          </div><!--/social-box-->
        </b-col>
        <b-col md="9" sm="6">
          <b-row class="full-width">
            <b-col cols="12" class="row m-0 p-0">
              <div class="pull-right">
                <b-input-group v-bind:prepend="$t('combo.display_date')">
                  <date-range-picker ref="drange" :startDate="filterDetail.startAt" :endDate="filterDetail.endAt" @update="updateDateRange" opens="left" :locale-data="date_locale" :ranges="ranges"></date-range-picker>
                </b-input-group>
              </div>
            </b-col>
            <b-col cols="12" class="row m-0 p-0">
              <!-- Start of Data table session -->
              <div class="table-responsive single-data">
                <table class="table table-striped table-hover table-sm table-bordered">
                  <thead>
                  <tr>
                    <th scope="col" v-for="item in dataTableDetail.fields" :key="item.id">
                      <span v-if="item.label != null">{{$t('store.'+item.label)}}</span>
                      <span v-if="item.label == null">{{$t('store.'+item.name)}}</span>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="dataTableDetail.items.length == 0">
                    <td class="text-center" :colspan="dataTableDetail.fields.length">
                      {{$t('message.no_data')}}
                    </td>
                  </tr>
                  <tr v-for="item in dataTableDetail.items" :key="item.id">
                    <td scope="row" class="text-left" v-for="field in dataTableDetail.fields" :key="field.id">
                      <span v-if="field.render != null" v-html="field.render(item[field.name], item)"></span>
                      <span v-if="field.render == null">
                        {{item[field.name]}}
                      </span>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <!-- End of Data table session -->
            </b-col>
          </b-row>

          <!-- Start of paginate session -->
          <b-row class="full-width">
            <b-col>
              <b-pagination :total-rows="dataTableDetail.total" :per-page="dataTableDetail.perPage"
                            v-model="dataTableDetail.currentPage"/>
            </b-col>
            <b-col class="text-left">
              {{$t('message.datatable_total', {number: dataTableDetail.items.length, total: dataTableDetail.total})}}
            </b-col>
            <b-col col lg="1">
              <b-form-select v-model="dataTableDetail.perPage" :options="[10, 20, 50, 100, 200, 500]" class="mb-3"/>
            </b-col>
          </b-row>
          <!-- Start of paginate session -->
        </b-col>
      </b-row>
      <div slot="modal-footer">
        <button type="button" class="btn border-radius-4px" v-on:click="$refs.storeDetailModal.hide()">
          {{$t('common.cancel')}}
        </button>
      </div>
    </b-modal>
    <!-- End Copy -->
  </div>
</template>
<script>
  import DateRangePicker from 'vue2-daterange-picker'
  import DatePicker from 'vue2-datepicker'
  import Multiselect from 'vue-multiselect'
  import SelectDropdown from '../../../components/Partials/SelectDropdown'

  let cancel = null
  let vm = null

  export default {
    name: 'StoreHealthCheck',
    components: {
      SelectDropdown,
      DateRangePicker,
      DatePicker,
      Multiselect,
    },
    data: function () {
      return {
        intervalLoadOrder: null,
        value: [],
        options: {},
        selectedStatus: {title: 'common.all', value: ''},
        statusOptions: {},
        outletsData: {},
        outletOptions: {},
        selectedStoreCode: '',
        map: {},
        filterDetail: {
          startAt: this.$moment().format('YYYY-MM-DD'),
          endAt: this.$moment().format('YYYY-MM-DD')
        },
        dataTableDetail: {
          items: [],
          fields: [
            {
              name: 'date_time',
              filter: false,
              sort: false
            },
            {
              name: 'status',
              filter: false,
              sort: false,
              render: function (data, row) {
                if (data == 'false') {
                  return '<img src="' + process.env.store_list_file_url + 'icons/red_dot_32.png' + '" width="15" /> ' + vm.$t('common.disconnected')
                }
                return '<img src="' + process.env.store_list_file_url + 'icons/green_dot_32.png' + '" width="15" /> ' + vm.$t('common.connected')
              }
            },
            {
              name: 'response',
              filter: false,
              sort: false
            }
          ],
          sort: {
            field: 'updated_at',
            type: 'desc'
          },
          currentPage: 1,
          total: 0,
          perPage: 20,
          source: null
        },
        filter: {
          options: [],
          selected: null,
          field: null,
          key: null,
          store_code: '',
          status: {title: 'common.all', value: ''}
        },
        dataTable: {
          items: [],
          fields: [
            {
              name: 'store_code',
              filter: true,
              sort: false
            },
            {
              name: 'store_name',
              filter: true,
              sort: false
            },
            {
              name: 'ip',
              filter: true,
              sort: false
            },
            {
              name: 'status',
              filter: false,
              sort: false,
              render: function (data, row) {
                if (data == 'false') {
                  return '<img src="' + process.env.store_list_file_url + 'icons/red_dot_32.png' + '" width="15" /> ' + vm.$t('common.disconnected')
                }
                return '<img src="' + process.env.store_list_file_url + 'icons/green_dot_32.png' + '" width="15" /> ' + vm.$t('common.connected')
              }
            }
          ],
          sort: {
            field: 'updated_at',
            type: 'desc'
          },
          currentPage: 1,
          total: 0,
          false: 0,
          true: 0,
          perPage: 20,
          source: null
        }
      }
    },
    methods: {
      updateDateRange (val) {
        this.date = val
        this.filterDetail.startAt = val.startDate != null ? this.$moment(val.startDate).format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD')
        this.filterDetail.endAt = val.endDate != null ? this.$moment(val.endDate).format('YYYY-MM-DD') : this.$moment().format('YYYY-MM-DD')
        this.getStoreStatus()
      },
      getDetails: function (storeCode) {
        vm.selectedStoreCode = storeCode
        vm.$refs.storeDetailModal.show()
        vm.getStoreStatus()
      },
      setStatus: function (status) {
        vm.selectedStatus = status
        vm.getLatestStoreStatus()
      },
      setStatusDatatable: function (status) {
        vm.filter.status = status
        vm.getLatestStoreStatusDatatable()
      },
      getOutlets: function (cb) {
        vm.axios.campaign.getStoreListFullDetails(function (response) {
          let outlets = response.data.data.items
          let langs = Object.keys(vm.$i18n.messages)
          let bounds = new google.maps.LatLngBounds()
          for (let o in outlets) {
            for (let l in langs) {
              vm.options[langs[l]].push({
                text: outlets[o].name[langs[l]] + outlets[o].code,
                value: outlets[o].code
              })
            }
            vm.outletsData[outlets[o].code] = outlets[o]
            vm.outletsData[outlets[o].code].coords = []
            // vm.setStoreMarket(bounds, vm.outletsData[outlets[o].code], '000.000.000.000', 'false')
          }
          vm.map.fitBounds(bounds)
          vm.map.panToBounds(bounds)
          cb()
        })
      },
      getLatestStoreStatus: function () {
        let params = '?'
        if (vm.selectedStatus.value != "") {
          params += 'status=' + vm.selectedStatus.value
        }
        vm.axios.report.getLatestStoreStatus(params, function (response) {
          let result = response.data.data.logs
          let bounds = new google.maps.LatLngBounds()
          for (let i in vm.outletsData) {
            if (vm.outletsData[i].marker != null) {
              vm.outletsData[i].marker.setMap(null)
            }
          }
          for (let i in result) {
            if (vm.outletsData[result[i].store_code]) {
              vm.outletsData[result[i].store_code].ip = result[i].ip
              vm.setStoreMarket(bounds, vm.outletsData[result[i].store_code], result[i].ip, result[i].status)
            }
          }
          vm.map.fitBounds(bounds)
          vm.map.panToBounds(bounds)
        })
      },
      getLatestStoreStatusDatatable: function () {
        let params = '?'
        if (vm.filter.status.value != "") {
          params += 'status=' + vm.filter.status.value + '&'
        }
        // get params
        let filter = {
          page: this.dataTable.currentPage,
          limit: this.dataTable.perPage
        }

        if (!this._.isEmpty(this.filter.field) && !this._.isEmpty(this.filter.key)) {
          filter[this.filter.field] = this.filter.key.trim()
        }

        for (let key in filter) {
          params += key + '=' + filter[key] + '&'
        }

        params = params.slice(0, -1)

        vm.axios.report.getLatestStoreStatus(params, function (response) {
          vm.dataTable.items = response.data.data.logs
          vm.dataTable.total = response.data.data.totalRecord
        })
      },
      setStoreMarket: function (bounds, store, ip, status) {
        let outletLatlng = new google.maps.LatLng(store.lat, store.long)
        bounds.extend(outletLatlng)
        let icon = {
          url: process.env.store_list_file_url + 'icons/red_dot_32.png',
          scaledSize: new google.maps.Size(10, 10),
          origin: new google.maps.Point(0, 0),
          anchor: new google.maps.Point(5, 5)
        }
        store.marker = new google.maps.Marker({
          position: outletLatlng,
          map: vm.map,
          // title: outlets[o].code,
          icon: icon
        })
        let infowindow = new google.maps.InfoWindow({
          content: vm.$t('store.outlet_code') + ': ' + store.code
            + '<br/>' + vm.$t('store.outlet_name') + ': ' + store.name[vm.$session.get('lang')]
            + '<br/>' + 'IP' + ': ' + ip
            + '<br/>' + vm.$t('store.status') + ': ' + status
        })

        vm.outletsData[store.code].marker.addListener('click', function () {
          infowindow.open(vm.map, store.marker)
        })

        vm.outletsData[store.code].marker.addListener('mouseover', function () {
          infowindow.open(vm.map, store.marker)
        })

        vm.outletsData[store.code].marker.addListener('mouseout', function () {
          infowindow.close(vm.map, store.marker)
        })
      },
      getStoreStatus: function () {
        let filter = {
          page: this.dataTableDetail.currentPage,
          limit: this.dataTableDetail.perPage,
          from: this.$moment(this.filterDetail.startAt + ' 00:00:00').utc().format('YYYY-MM-DD HH:mm:ss'),
          to: this.$moment(this.filterDetail.endAt + ' 23:59:59').utc().format('YYYY-MM-DD HH:mm:ss')
        }

        let params = '?'
        for (let key in filter) {
          params += key + '=' + filter[key] + '&'
        }
        params = params.slice(0, -1)

        vm.axios.report.getStoreStatus(params, function (response) {
          vm.dataTableDetail.items = response.data.data.logs
          vm.dataTableDetail.total = response.data.data.totalRecord
          vm.dataTableDetail.false = response.data.data.totalFalse
          vm.dataTableDetail.true = response.data.data.totalRecord - response.data.data.totalFalse
        })
      }
    },
    created: function () {
      vm = this
      let langs = Object.keys(this.$i18n.messages)
      for (let l in langs) {
        this.options[langs[l]] = []
      }
      this.statusOptions = [
        {title: 'common.all', value: ''},
        {title: 'common.connected', img: process.env.store_list_file_url + 'icons/green_dot_32.png', value: 'true'},
        {title: 'common.disconnected', img: process.env.store_list_file_url + 'icons/red_dot_32.png', value: 'false'}
      ]
      for (let i in this.dataTable.fields) {
        if (this.dataTable.fields[i].filter != null && this.dataTable.fields[i].filter == true) {
          this.filter.options.push(this.dataTable.fields[i])
        }
      }
    },
    mounted: function () {
      let vm = this
      const element = document.getElementById('myMap')
      const options = {
        zoom: 15,
        center: new google.maps.LatLng(37.775, -122.434),
        keyboardShortcuts: false
      }
      vm.map = new google.maps.Map(element, options)
      vm.getOutlets(function () {
        vm.getLatestStoreStatus()
        vm.getLatestStoreStatusDatatable()
        this.intervalLoadOrder = setInterval(function () {
          vm.getLatestStoreStatus()
        }, 5 * 60 * 1000)
      })
    },
    beforeDestroy: function () {
      clearInterval(this.intervalLoadOrder)
    },
    watch: {
      'filter.key': function (val) {
        vm.getLatestStoreStatusDatatable()
      },
      'dataTable.currentPage': function (val) {
        vm.getLatestStoreStatusDatatable()
      },
      'dataTable.perPage': function (val) {
        vm.getLatestStoreStatusDatatable()
      },
      'dataTableDetail.currentPage': function (val) {
        vm.getStoreStatus()
      },
      'dataTableDetail.perPage': function (val) {
        vm.getStoreStatus()
      },
    },
    computed: {
      date_locale: function () {
        let format = this.format_date_range_locale()
        if (this.$refs.drange) {
          this.$refs.drange.locale = format
        }
        return format
      },
      ranges: function () {
        return this.format_date_ranges()
      }
    }
  }
</script>
<style>
  .roster-report-list .date-range-custom .form-control {
    padding: 10px;
  }

  .date-range-custom .multiselect .multiselect__tags {
    border-radius: 0px !important;
    height: 43px;
  }

  .date-range-custom .multiselect {
    min-height: 43px !important;
  }
</style>
<style scoped>
  #myMap {
    height: 680px;
    width: 100%;
  }

  .btn-height {
    max-height: 43px;
    min-height: 43px;
  }

  .pull-right {
    margin-right: 10px;
  }

  .multiselect {
    width: 240px !important;
  }

  .multiselect__select {
    height: 32px !important;
    margin-right: 10px !important;
  }

  .multiselect__single {
    margin-bottom: 7px !important;
    margin-top: 1px !important;
    font-size: 14px !important;
  }

  .multiselect__content-wrapper {
    min-width: 240px;
    max-width: 240px;
  }

  .col-sm-6 {
    float: left;
  }

  .dashboard-stat {
    border-radius: 6px;
    -moz-border-radius: 6px;
    -webkit-border-radius: 6px;
    padding: 10px 20px;
    margin-bottom: 10px;
    color: #FFF;
  }

  .icon {
    position: absolute;
    font-size: 5.5em;
    left: 0px;
    top: -10px;
    z-index: 10;
    color: #E4E5E6;
    opacity: 0.3;
  }

  .blue {
    background: #4B8DF8;
    border-bottom: 10px solid #3D85F7;
  }

  .green {
    background: #35AA47;
    border-bottom: 10px solid #319F43;
  }

  .red {
    background: #D84A38;
    border-bottom: 10px solid #D4402E;
  }

  .details {
    text-align: right;
    font-size: 26px;
  }

  .desc {
    font-size: 0.7em;
  }

  .multiselect .multiselect__tags {
    min-height: 35px;
    display: block;
    padding: 8px 40px 0 8px;
    border-radius: 0 !important;
    border: 1px solid #e8e8e8;
    background: #fff;
    font-size: 12px;
  }

  .mode-btn {
    background-color: #D4402E;
    color: #FFF;
  }

  .mode-btn:hover {
    background-color: #D84A38;
  }

  .mode-btn:focus {
    background-color: #D84A38;
  }

  .dropdown {
    float: right;
  }

  .dropdown .btn {
    border-radius: 4px !important;
  }

  .dropdown ul {
    margin-top: 0px !important;
  }

  .color-white {
    color: #fff;
  }

  .social-box ul {
    height: 60px;
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// src/views/admin/report/StoreHealthCheck.vue